import { KEYS } from '@/components/custom/editor/stringKeys/StringKeys'

export const handleDownload = async (fileName: string) => {
    if (typeof window !== 'undefined') {
        try {
            const html2pdf = (await import('html2pdf.js')).default
            const options = {
                margin: 10,
                filename: `${fileName}-screenplay.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            }
            const element = document.getElementById(KEYS.SP_PDF_CONTENT)?.innerHTML
            html2pdf()
                .from(element)
                .set(options)
                .save()
                .then(() => {
                    console.log('PDF downloaded successfully')
                })
                .catch((error: any) => {
                    console.error('Error downloading PDF:', error)
                })
        } catch (error) {
            console.error('Error loading html2pdf.js:', error)
        }
    }
}
